import { render, staticRenderFns } from "./AbColorCombo.vue?vue&type=template&id=71184108&scoped=true"
import script from "./AbColorCombo.vue?vue&type=script&lang=js"
export * from "./AbColorCombo.vue?vue&type=script&lang=js"
import style0 from "./AbColorCombo.vue?vue&type=style&index=0&id=71184108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71184108",
  null
  
)

export default component.exports